import React from 'react';
import {Route, IndexRoute} from 'react-router';

import { loginRequired, logoutRequired } from './utils/auth'

import Home from './home/containers/HomeContainer';
import Login from './home/containers/LoginContainer';
import ResetPassword from './home/containers/ResetPasswordContainer';
import ResetPasswordConfirmation from './home/containers/ResetPasswordConfirmationContainer';
import ChangePassword from './user/containers/ChangePasswordContainer';
import ChangePasswordConfirmation from './user/containers/ChangePasswordConfirmationContainer';
import UserLoggedRedirect from './user/containers/UserLoggedRedirectContainer';
import UserLogged from './user/containers/UserLoggedContainer';
import Register from './home/containers/RegisterContainer';
import RegisterConfirmation from './user/containers/RegisterConfirmationContainer';
import BtoCLayout from './btoc/containers/layout/BtoCLayoutContainer'
import BtoBLayout from './btob/containers/layout/BtoBLayoutContainer'
import ProfileProvider from './btoc/containers/ProfileContainer'
import RegisterProfile from './btoc/containers/RegisterProfileContainer'
import UpdateProfile from './btoc/containers/UpdateProfileContainer'
import ConfirmationUpdateRegister from './btoc/containers/ConfirmationUpdateRegisterContainer'
import Documents from './btoc/containers/DocumentsContainer'

import Dashboard from './btob/containers/DashboardContainer'
import NewLead from './btob/containers/NewLeadContainer'
import Lead from './btob/containers/LeadContainer'
import Task from './btob/containers/TaskContainer'
import ProviderList from './btob/containers/ProviderListContainer'
import ManagerProvider from './btob/containers/ProviderContainer'
import ManagerUpdateProvider from './btob/containers/UpdateProviderContainer'
import UpdateProviderStatus from './provider/containers/UpdateProviderStatusContainer'

import App from './core/containers/AppContainer';

 

export default (
    <Route path="/" component={App}>
        <IndexRoute component={Home} />

        <Route onEnter={logoutRequired}>
            <Route path="login" component={Login} />
            <Route path="register" component={Register} />
            <Route path="password" component={ResetPassword} />
            <Route path="password/confirmation" component={ResetPasswordConfirmation} />
            <Route path="reset/:token" component={ChangePassword} />
            <Route path="reset-confirmation" component={ChangePasswordConfirmation} />
        </Route>

        <Route path="confirmation" component={RegisterConfirmation} />

        <Route onEnter={loginRequired} component={UserLogged}>
            <Route path="login/redirect" component={UserLoggedRedirect} />
        	<Route component={BtoCLayout}>
                <Route path="prestataire/fiche" component={ProfileProvider} />
                <Route path="prestataire/fiche/update" component={UpdateProfile} />
                <Route path="prestataire/fiche/inscription" component={RegisterProfile} />
                <Route path="prestataire/documents" component={Documents} />
            </Route>
            <Route component={BtoBLayout}>
                <Route path="manager/dashboard(/:regionParam)" component={Dashboard} />
                <Route path="manager/lead/new" component={NewLead} />
                <Route path="manager/leads(/:regionParam)" component={Lead} />
                <Route path="manager/tasks(/:regionParam)" component={Task} />
                <Route path="manager/prestataires(/:regionParam)" component={ProviderList} />
                <Route path="manager/prestataire/:provider_id" component={ManagerProvider} />
                <Route path="manager/prestataire/:provider_id/update" component={ManagerUpdateProvider} />
        	</Route>
            <Route path="manager/prestataire/:provider_id/status" component={UpdateProviderStatus} />
        </Route>

        <Route onEnter={loginRequired}>
            <Route path="prestataire/confirmation" component={ConfirmationUpdateRegister} />
        </Route>

    </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js